/**
 * Shared money / cycle formatting for the super-admin billing surfaces.
 *
 * Lifted verbatim out of CompanyDetails when the provisioning dialog was
 * extracted — the dialog renders currency, and a second copy of this would be
 * a second place for the rounding rules below to drift.
 */

/**
 * Money is always rendered to exactly two decimals.
 *
 * Without minimumFractionDigits, toLocaleString drops a trailing zero — a
 * ₹21,169.20 charge printed as "21,169.2", which reads as a truncated number
 * rather than a currency amount. The value itself was never wrong; only this
 * formatter was. Matches formatCurrency on the company-facing Upgrade Plan page
 * so the same amount reads identically on both sides.
 */
export const money = (amt, currency = "INR") => {
  if (amt == null) return "—";
  // Number("") is 0, so an empty/blank value would otherwise render as a
  // confident "INR 0.00" — an absent amount, asserted as free.
  if (typeof amt === "string" && amt.trim() === "") return "—";
  const n = Number(amt);
  /**
   * Anything that will not parse renders as a missing value, never "NaN".
   *
   * A cell printed "INR NaN" for a row whose amount had been stored as the
   * STRING "35,282.00" — the thousands separator makes Number() return NaN, and
   * NaN is not == null so the caller's own null-guard let it through. Degrading
   * to "—" keeps a bad row legible instead of showing the user a broken number;
   * the underlying value is still wrong and still needs correcting at the source.
   */
  if (!Number.isFinite(n)) return "—";
  return `${currency} ${n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const capCycle = (c) => (c ? c.charAt(0).toUpperCase() + c.slice(1) : "");
